import { render } from "./IconHistory.vue?vue&type=template&id=6213a26e&ts=true"
import script from "./IconHistory.vue?vue&type=script&lang=ts"
export * from "./IconHistory.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__